import {
  SET_USER_ID,
  SET_USER_COOKIES,
  SET_USER_WEB_CONVERSION,
  SET_USER_GCLID_CONVERSION,
} from '../actions'
import initialState from '../state/user.state'

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_USER_ID: {
      const { id } = action.payload
      return { ...state, id }
    }
    case SET_USER_COOKIES: {
      const { cookies } = action.payload
      return { ...state, cookies }
    }
    case SET_USER_WEB_CONVERSION: {
      const { isWebConversionSended } = action.payload
      return { ...state, isWebConversionSended }
    }
    case SET_USER_GCLID_CONVERSION: {
      const { isGclidConversionSended } = action.payload
      return { ...state, isGclidConversionSended }
    }
    default:
      return state
  }
}
